import React from "react";

const PrivacyContent = () => {
  return (
    <div className="privacy-content">
      <section className="privacy-section">
        <h3>1. Information We Collect</h3>
        <p>
          Omaha Food Lovers collects information you provide directly to us, such as when you create an account, 
          make a purchase, or communicate with us. This may include:
        </p>
        <ul>
          <li>Name, email address, and contact information</li>
          <li>Payment information (processed securely through third-party payment processors)</li>
          <li>Dining preferences and restaurant activity</li>
          <li>Account credentials and authentication tokens</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>2. How We Use Your Information</h3>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Process transactions and send you related information</li>
          <li>Send you technical notices and support messages</li>
          <li>Respond to your comments, questions, and customer service requests</li>
          <li>Monitor and analyze trends, usage, and activities in connection with our services</li>
          <li>Detect, prevent, and address technical issues and fraud</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>3. Information Sharing</h3>
        <p>
          We do not sell your personal information. We may share your information only in the following circumstances:
        </p>
        <ul>
          <li>With service providers who perform services on our behalf (e.g., payment processing, data hosting)</li>
          <li>To comply with legal obligations, court orders, or government requests</li>
          <li>To protect our rights, property, and safety</li>
          <li>In connection with a merger, acquisition, or sale of assets</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>4. Data Security</h3>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information 
          against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
          over the Internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section className="privacy-section">
        <h3>5. Your Rights</h3>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request deletion of your personal information</li>
          <li>Opt-out of marketing communications</li>
          <li>Object to processing of your personal information</li>
          <li>Request a copy of your personal data</li>
        </ul>
        <p>
          To exercise these rights, please contact us at privacy@omahafoodlovers.com
        </p>
      </section>

      <section className="privacy-section">
        <h3>6. Cookies and Tracking</h3>
        <p>
          We use cookies and similar technologies to collect information about your browsing activities and 
          preferences. You can control cookies through your browser settings, but disabling cookies may affect 
          your ability to use certain features of our service.
        </p>
      </section>

      <section className="privacy-section">
        <h3>7. Children's Privacy</h3>
        <p>
          Our services are not intended for children under 13 years of age. We do not knowingly collect 
          personal information from children under 13. If you are a parent or guardian and believe your child 
          has provided us with personal information, please contact us.
        </p>
      </section>

      <section className="privacy-section">
        <h3>8. Changes to This Policy</h3>
        <p>
          We may update this privacy policy from time to time. We will notify you of any material changes by 
          posting the new policy on this page and updating the "Last updated" date.
        </p>
      </section>

      <section className="privacy-section">
        <h3>9. Contact Us</h3>
        <p>
          If you have any questions about this privacy policy or our data practices, please contact us at:
        </p>
        <p className="contact-info">
          Email: privacy@omahafoodlovers.com<br />
          Address: Omaha, Nebraska
        </p>
      </section>
    </div>
  );
};

export default PrivacyContent;
